import {FC} from "react";
import {Link} from "../../../ui";
import styled from "styled-components";
import {PublicServicesInform} from "../";
import {LoadingIcon} from "../../../ui/Icons";
import useDrawer from "../../../hooks/useDrawer";
import Loading from "../../../ui/Loading/Loading";
import {useGetRootPublicServiceByIdQuery} from "./__generated__/PublicServicesRoot.query.generated";

const Options = styled.div`
  h2 {
    font-weight: 400;
    color: ${props => props.theme.palette.purple};
  }
  ul {
    display: flex;
    flex-direction: column;
  }
`;

const PublicServicesRoot:FC = () => {
  const { id, openChildrenHandler } = useDrawer();
  const { data, loading, error } = useGetRootPublicServiceByIdQuery({ variables: { id }});

  if (loading || !data) {
    return (
      <Loading><LoadingIcon /></Loading>
    );
  }

  if (error) {
    return <p>{error.message}</p>;
  }

  if (!data?.getServicesCategoryById) {
    return <p>Возможно произошла ошибка или ID был пуст</p>;
  }

  return (
     <>
       <PublicServicesInform
         info={data?.getServicesCategoryById}
       />
       <Options>
         <h2>Управление категорией</h2>
         <ul>
           <Link colorTheme="green" onClick={() => openChildrenHandler('publicServicesSettingsEdit')}>Редактировать категорию</Link>
           <Link colorTheme="red" onClick={() => openChildrenHandler('publicServicesSettingsDelete')}>Удалить категорию</Link>
         </ul>
       </Options>
     </>
  )
}

export default PublicServicesRoot;
